import { render } from "./DateFilter.vue?vue&type=template&id=2bb6b2c2&ts=true"
import script from "./DateFilter.vue?vue&type=script&lang=ts"
export * from "./DateFilter.vue?vue&type=script&lang=ts"

import "./DateFilter.vue?vue&type=style&index=0&id=2bb6b2c2&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__